import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbBannerUtils } from "abreact/app/banner/AbBannerUtils";
import { BaseRCmp } from "abreact/incubator/ui/component/BaseRCmp";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbWebServices } from "abweb/service/AbWebServices";
import * as React from "react";
/* eslint-disable react/forbid-elements */

export class AbProductBranding extends BaseRCmp {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_customBrandingPath", AbBannerUtils.customBrandingPath(AbProductBranding.CUSTOM_PRODUCT_INFO));
    _defineProperty(this, "_defaultBrandingPath", AbBannerUtils.customBrandingPath(AbProductBranding.DEFAULT_PRODUCT_INFO));
    _defineProperty(this, "_legalBrandingPath", AbBannerUtils.customBrandingPath(AbProductBranding.LEGAL_PRODUCT_INFO));
  }
  getContents() {
    if (!this.props.excludeCustomerBranding && this._customBrandingPath) {
      return /*#__PURE__*/React.createElement("img", {
        src: this._customBrandingPath,
        className: "ab-product-branding-custom",
        alt: AbWebServices.sessionData.productInfo.name
      });
    }
    if (this.props.useLegalBranding && this._legalBrandingPath) {
      return /*#__PURE__*/React.createElement("img", {
        src: this._legalBrandingPath,
        className: "ab-product-branding-default",
        alt: AbWebServices.sessionData.productInfo.name
      });
    }
    if (this._defaultBrandingPath) {
      return /*#__PURE__*/React.createElement("img", {
        src: this._defaultBrandingPath,
        className: "ab-product-branding-default",
        alt: AbWebServices.sessionData.productInfo.name
      });
    }
    return AbWebServices.sessionData.productInfo.name;
  }
  render() {
    return /*#__PURE__*/React.createElement("div", _extends({}, ReactUtils.componentProps("ab-product-branding", this.props), {
      "data-test-id": "product-name"
    }), this.getContents());
  }
}
// Name of the items in the product info
_defineProperty(AbProductBranding, "CUSTOM_PRODUCT_INFO", "customProductPath");
_defineProperty(AbProductBranding, "DEFAULT_PRODUCT_INFO", "defaultProductPath");
_defineProperty(AbProductBranding, "LEGAL_PRODUCT_INFO", "legalProductPath");
//# sourceMappingURL=AbProductBranding.js.map
